import React from "react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";

export default function NotFoundPage() {
  return (
    <div data-testid="page-404">
      <PageHeader
        eyebrow="404"
        title={
          <>
            Strona której szukasz{" "}
            <span className="gold-gradient-text italic">nie istnieje</span>
          </>
        }
        subtitle="Ta podstrona mogła zostać usunięta lub adres jest nieprawidłowy. Wróć na stronę główną lub sprawdź ofertę."
      >
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" className="btn-gold">
            Strona główna →
          </Link>
          <Link to="/oferta" className="btn-ghost">
            Zobacz ofertę
          </Link>
        </div>
      </PageHeader>
    </div>
  );
}
